import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Table } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import styles from './style.module.scss';
import QuoteRequestService from '../../services/quote-request';
import {maskDocument, documentType, maskZip} from 'helpers/document';
import { useParams } from 'react-router-dom';

const QuoteRequestShow = () => {
  const [quoteRequest, setQuoteRequest] = useState({});
  const [quote, setQuote] = useState({});
  const [subcategory, setSubcategory] = useState({});
  const [category, setCategory] = useState({});
  const [manufacturer, setManufacturer] = useState({});
  const [companies, setCompanies] = useState([]);
  const [document, setDocument] = useState('');
  const [contact, setContact] = useState([]);
  const [email, setEmail] = useState([]);
  const [address, setAddress] = useState([]);
  const id = useParams().id;

  useEffect(() => {
    listQuoteRequest(id);
  }, [id]);

  const listQuoteRequest = (id) => {
    let quoteRequestPromise = QuoteRequestService.getQuote(id);
    quoteRequestPromise.then(data => {
      setQuoteRequest(data.data);
      setQuote(data.data.additional_info);
      setSubcategory(data.data.subcategory);
      setCategory(data.data.subcategory.category);
      setManufacturer(data.data.manufacturer.subcategory_manufacturer.manufacturer);
      setCompanies(data.data.recommended_companies);
      setDocument(data.data.document.document);
      setContact(data.data.contact);
      setEmail(data.data.email.email);
      setAddress(data.data.address);
    }
    ).catch(err => console.log("Err:" + err));
  };


  const renderData = info => {

    return info.map((data, k) => {
      return <tr key={data.id} className="font-11">
        <td> {k + 1} </td>
        <td> {data.name ? data.name : "--"} </td>
        <td> {data.alias ? data.alias : "--"} </td>
        <td> {data.address_state ? data.address_state : "--"} </td>
        <td> {data.address_city ? data.address_city : "--"} </td>
      </tr>
    });

  }

  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col className="align-self-center">
                    <h3 className={styles.headerTitle}>
                      {quoteRequest.deal_name}
                    </h3>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>Informações de Contato</p>
                  </Col>
                </Row>
                <Row>
                  <Col xs={4}>
                    <p className={styles.fontSize1}><span className={styles.bold}>Nome:</span> {contact.name}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>E-mail:</span> {email}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>{documentType(document)}:</span> {maskDocument(document)}</p>
                  </Col>
                  <Col xs={4}>
                    <p className={styles.fontSize1}><span className={styles.bold}>Cidade:</span> {address.address_city}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Estado:</span> {address.address_state}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>CEP:</span> {maskZip(address.address_zipcode)}</p>
                  </Col>
                  <Col xs={4}>
                    <p className={styles.fontSize1}><span className={styles.bold}>Endereço:</span> {address.address}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Complemento:</span> {address.address_complement ? address.address_complement : '--' }</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Bairro:</span> {address.address_neighborhood}</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>Cotação</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className={styles.fontSize1}><span className={styles.bold}>Fabricante: </span>{manufacturer.name}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Categoria: </span>{category.name}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Subcategoria: </span>{subcategory.name}</p>
                    <p className={styles.fontSize1}><span className={styles.bold}>Solicitação: </span>{quote.description}</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <hr className={styles.line} />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p>Recomendações</p>
                    {
                      companies.length > 0 ? 
                    
                    <Table>
                      <thead className="font-12 thead-light">
                        <tr>
                          <th> # </th>
                          <th> Razão Social</th>
                          <th> Nome Fantasia </th>
                          <th className="w-15"> Estado </th>
                          <th className="w-15"> Cidade </th>
                        </tr>
                      </thead>
                      <tbody>
                        {renderData(companies)}
                      </tbody>
                    </Table>
                    : 
                    <h5 className="text-center">Ainda não foi recomendada nenhuma revenda para esta solicitação de orçamento</h5>
                    }
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default MasterPage(QuoteRequestShow);